import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

const EndUserLicenseAgreement = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <main className="flex-grow bg-white pt-20 md:pt-24">
        <div className="container mx-auto px-6 md:px-4 py-8 md:py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl font-medium text-gray-800 mb-4 font-trends">
              End User License Agreement
            </h1>
            <h2 className="text-xl sm:text-2xl text-gray-800 mb-6 font-trends">
              Chase the Chickens
            </h2>
            <p className="text-gray-600 mb-8">Effective Date: January 12, 2025</p>

            <p className="text-lg md:text-xl text-gray-800 mb-8">
              This End User License Agreement ("EULA") is a legal agreement between you and Rock Software for the Chase the Chickens mobile application software and any associated media, documentation, and updates ("Software").
            </p>

            <div className="space-y-8 md:space-y-12">
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">1. License Grant</h2>
                <p className="text-gray-600">
                  Rock Software grants you a limited, non-exclusive, non-transferable, revocable license to download, install, and use the Software for your personal, non-commercial use on authorized devices.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">2. Intellectual Property Rights</h2>
                <p className="text-gray-600">
                  The Software, including all content, features, and functionality, is owned by Rock Software © 2025. All rights reserved. The Software is protected by international copyright, trademark, and other intellectual property laws. No ownership rights are transferred through this license.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">3. Restrictions</h2>
                <p className="text-gray-600 mb-4">You agree not to:</p>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Copy, modify, or create derivative works of the Software</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Reverse engineer, decompile, or disassemble the Software</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Remove or alter any copyright or trademark notices</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Rent, lease, sublicense, or transfer the Software</span>
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">4. Updates and Maintenance</h2>
                <p className="text-gray-600">
                  Rock Software may deploy updates, patches, or modifications to the Software at any time. These updates may be automatic and mandatory for continued use of the Software. We may modify or discontinue features without prior notice.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">5. Data Collection and Privacy</h2>
                <p className="text-gray-600">
                  The Software collects and transmits data as described in our Privacy Policy. By using the Software, you consent to such data collection and transmission.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">6. Warranty Disclaimer</h2>
                <p className="text-gray-600">
                  THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. ROCK SOFTWARE DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">7. Limitation of Liability</h2>
                <p className="text-gray-600">
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW, ROCK SOFTWARE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO THE USE OF THE SOFTWARE.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">8. Termination</h2>
                <p className="text-gray-600">
                  This license is effective until terminated. Your rights under this license will terminate automatically without notice if you fail to comply with any of its terms. Upon termination, you must cease all use of the Software and destroy all copies.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">9. Governing Law</h2>
                <p className="text-gray-600">
                  This EULA shall be governed by and construed in accordance with the laws of the United Kingdom, without regard to its conflict of law principles.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">Contact Us</h2>
                <p className="text-gray-600 mb-4">For questions about this EULA, please contact us at:</p>
                <div className="space-y-2 text-gray-600">
                  <p><strong>Email:</strong> legal@chasethechickens.co.uk</p>
                  <p><strong>Mail:</strong> Rock Software, 123 Game Street, London, UK</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default EndUserLicenseAgreement;